var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.record.isTotalRow
    ? _c(
        "div",
        {
          staticClass: "orders-number-cell",
          class: {
            "orders-number-cell-not-clickable":
              !_vm.canEdit ||
              (_vm.record.orders && _vm.record.orders.value == 0) ||
              (_vm.record.number_of_orders &&
                _vm.record.number_of_orders.value == 0),
          },
          on: { click: _vm.clickHandler },
        },
        [
          _c(
            "c-sidesheet",
            {
              staticClass: "orders-number-cell-sidesheet",
              attrs: { active: _vm.isShowOrdersModal },
              on: { close: _vm.closeOrdersModal },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "orders-number-cell-sidesheet-close",
                  attrs: {
                    width: "15",
                    height: "16",
                    viewBox: "0 0 15 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                  on: { click: _vm.closeOrdersModal },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                      fill: "#8E9CBB",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                      fill: "#8E9CBB",
                    },
                  }),
                ]
              ),
              _c("div", { staticClass: "orders-number-cell-sidesheet-title" }, [
                _c(
                  "div",
                  { staticClass: "orders-number-cell-sidesheet-title-desc" },
                  [_vm._v("Заказы водителя")]
                ),
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass:
                          "orders-number-cell-sidesheet-title-employee",
                        attrs: {
                          target: "_blank",
                          to: {
                            name: "personal-employee-summary",
                            params: {
                              id:
                                _vm.currentDriverLocalValue !== null
                                  ? _vm.currentDriverLocalValue.value
                                  : _vm.record.id,
                            },
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.currentDriverLocalValue !== null
                                ? _vm.currentDriverLocalValue.label
                                : _vm.record.employee.value
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c("c-button-dropdown", {
                      staticClass:
                        "orders-number-cell-sidesheet-title-dropdown",
                      attrs: {
                        icon: "arrow",
                        type: "dropdown",
                        dropdown: {
                          position: "left",
                          items: _vm.driversLocalItems,
                        },
                      },
                      on: { changeWorker: _vm.changeWorker },
                    }),
                  ],
                  1
                ),
              ]),
              _c("c-tabs", {
                ref: "tabs",
                staticClass: "orders-number-cell-sidesheet-tabs",
                attrs: { active: _vm.activeTab, items: _vm.tabs.items },
                on: { change: _vm.changeTab },
              }),
              _c("div", { staticClass: "position-relative h-100" }, [
                _c("div", {
                  staticClass: "orders-number-cell-sidesheet-table-shadow-top",
                  attrs: {
                    id: "orders-number-cell-sidesheet-table-shadow-top",
                  },
                }),
                _c(
                  "div",
                  {
                    staticClass: "orders-number-cell-sidesheet-table",
                    attrs: { id: "orders-number-cell-sidesheet-table" },
                    on: { scroll: _vm.setShadowsOnScroll },
                  },
                  [
                    _vm.isDataLoading
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "orders-number-cell-sidesheet-table-loader",
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: _vm.icon, spin: "" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.isDataLoading
                      ? _c("c-table-data-orders", {
                          ref: "table",
                          staticClass:
                            "orders-number-cell-sidesheet-table-table",
                          attrs: {
                            "empty-records-label": "Записи не найдены",
                            levels: 1,
                            "disabled-columns": _vm.tableData.disabledColumns,
                            "is-show-nested-orders-in-routes-tab": true,
                            data: _vm.tableData,
                            "active-tab": _vm.activeTab,
                          },
                          on: {
                            changeDriver: _vm.changeDriver,
                            recountDriver: _vm.recountDriver,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", {
                  staticClass:
                    "orders-number-cell-sidesheet-table-shadow-bottom",
                  attrs: {
                    id: "orders-number-cell-sidesheet-table-shadow-bottom",
                  },
                }),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "orders-number-cell-value" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.calculationType === "byPeriod"
                    ? _vm.record.orders.value
                    : _vm.record.number_of_orders.value
                ) +
                " "
            ),
          ]),
        ],
        1
      )
    : _c("div", { staticClass: "orders-number-cell-sum-row" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.calculationType === "byPeriod"
                ? _vm.record.orders.value
                : _vm.record.number_of_orders.value
            ) +
            " "
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }